/* eslint-disable no-console */
import { sendErrorAnalytics } from '../../catalog/Analytics';
import { FETCH_STAFFS_ERROR } from '../../catalog/NotificationsComments';
import { optimXTesting } from '../../catalog/TeamInfo';
import { fetchStaffsFirestoreAPI } from '../../firebase/firebaseAPICalls/FirebaseAPICallsStaff';

export const fetchStaffsAPI = async (teamId: string, setState: Function, snackbar: Function) => {
    const staffs: any = [];
    try {
        const docs = await fetchStaffsFirestoreAPI(teamId);
        docs.forEach((doc) => {
            if (doc.exists) {
                staffs.push({ ...doc.data() });
            }
        });
        setState({ type: 'fetchStaffs', staffs });
    } catch (error) {
        sendErrorAnalytics(FETCH_STAFFS_ERROR);
        if (optimXTesting) {
            snackbar(FETCH_STAFFS_ERROR, { variant: 'error' });
            console.log(error);
        }
    }
};
